import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const isMobile = computed(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
  })
  const shouldShowTabBar = ref(true)

  const showCommentSets = ref(new Set<number>())
  const showEpisodeSets = ref(new Set<number>())

  const activeMobilePanel = ref<'none' | 'comment' | 'episode'>('none')
  const activeMobileScriptId = ref<number | null>(null)

  const showComments = (scriptId: number) => {
    showEpisodeSets.value.delete(scriptId)
    showCommentSets.value.add(scriptId)

    if (isMobile.value) {
      activeMobilePanel.value = 'comment'
      activeMobileScriptId.value = scriptId
    }
  }

  const hideComments = (scriptId: number) => {
    showCommentSets.value.delete(scriptId)
    if (isMobile.value && activeMobilePanel.value === 'comment' && activeMobileScriptId.value === scriptId) {
      activeMobilePanel.value = 'none'
      activeMobileScriptId.value = null
    }
  }

  const toggleShowComments = (scriptId: number) => {
    if (showCommentSets.value.has(scriptId)) {
      hideComments(scriptId)
      return
    }
    showComments(scriptId)
  }

  const showEpisodes = (scriptId: number) => {
    showCommentSets.value.delete(scriptId)
    showEpisodeSets.value.add(scriptId)

    if (isMobile.value) {
      activeMobilePanel.value = 'episode'
      activeMobileScriptId.value = scriptId
    }
  }

  const hideEpisodes = (scriptId: number) => {
    showEpisodeSets.value.delete(scriptId)
    if (isMobile.value && activeMobilePanel.value === 'episode' && activeMobileScriptId.value === scriptId) {
      activeMobilePanel.value = 'none'
      activeMobileScriptId.value = null
    }
  }

  const toggleShowEpisode = (scriptId: number) => {
    if (showEpisodeSets.value.has(scriptId)) {
      hideEpisodes(scriptId)
      return
    }
    showEpisodes(scriptId)
  }

  const closeMobilePanel = () => {
    if (activeMobileScriptId.value == null) {
      activeMobilePanel.value = 'none'
      return
    }

    if (activeMobilePanel.value === 'comment') {
      showCommentSets.value.delete(activeMobileScriptId.value)
    }
    if (activeMobilePanel.value === 'episode') {
      showEpisodeSets.value.delete(activeMobileScriptId.value)
    }
    activeMobilePanel.value = 'none'
    activeMobileScriptId.value = null
  }

  const syncTabBarVisibility = (routeShowTabBar?: boolean) => {
    if (!isMobile.value) {
      shouldShowTabBar.value = true
      return
    }
    shouldShowTabBar.value = routeShowTabBar === true
  }

  return {
    isMobile,
    shouldShowTabBar,
    syncTabBarVisibility,
    activeMobilePanel,
    activeMobileScriptId,
    closeMobilePanel,

    showCommentSets,
    toggleShowComments,
    showComments,
    hideComments,

    showEpisodeSets,
    toggleShowEpisode,
    showEpisodes,
    hideEpisodes,
  }
})
